import { render } from "./F1inSchools.vue?vue&type=template&id=1c704fcc&scoped=true"
import script from "./F1inSchools.vue?vue&type=script&lang=js"
export * from "./F1inSchools.vue?vue&type=script&lang=js"

import "./F1inSchools.vue?vue&type=style&index=0&id=1c704fcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c704fcc"]])

export default __exports__